import * as React from "react";

function SvgIcWarranty(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4.585a6 6 0 100 12 6 6 0 000-12zm-8 6a8 8 0 1114.75 4.296l1.673 5.272a.75.75 0 01-.994.923l-1.798-.721-1.197 1.523a.75.75 0 01-1.3-.224l-1.117-3.326a8.01 8.01 0 01-2.017.257 8.012 8.012 0 01-1.993-.25l-1.142 3.324a.75.75 0 01-1.3.22L6.37 20.354l-1.798.721a.75.75 0 01-.993-.926l1.692-5.238A7.963 7.963 0 014 10.585zm11.427 7.23l.686 2.044.685-.873a.75.75 0 01.87-.233l.844.339-.893-2.813a8.017 8.017 0 01-2.192 1.537zm-9.028-1.518a8.018 8.018 0 002.196 1.529l-.701 2.042-.692-.882a.75.75 0 00-.87-.233l-.835.335.902-2.791z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.53 8.47a.75.75 0 010 1.06l-4 4a.75.75 0 01-1.06 0l-2-2a.75.75 0 111.06-1.06L11 11.94l3.47-3.47a.75.75 0 011.06 0z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcWarranty;
